import type { AuthProviderType } from '@terra/shared-authorization';
import { getAuthProviderType } from '../../utils/getAuthProviderType';
import { descopeAuthProvider } from './descope-auth-provider';
import { openIdAuthProvider } from './openid-auth-provider';
import { localAuthProvider } from './local-auth-provider';
import type { AuthProvider } from './types';

const authProviders: Record<AuthProviderType, AuthProvider> = {
  descope: descopeAuthProvider,
  openid: openIdAuthProvider,
  local: localAuthProvider,
};

export const getAuthProvider = (): AuthProvider => {
  const providerType = getAuthProviderType();
  return authProviders[providerType] ?? descopeAuthProvider;
};
